<template>
    <div class="estate-share-container" id="estate-share">
        <modal
            name="share-with-friend"
            ref="calculate-mortgage"
            extra-class="share-with-friend-modal full-screen-modal"
        >
            <template slot="body">
                <share-with-friend
                    :estate-id="estate.id"
                    :type="estate.ad_type"
                />
            </template>
        </modal>

        <img src="/img/icons/share.svg" :alt="lang.share" @click="toggleMenu"  width="24" height="24">

        <div v-if="show" class="estate-share-menu">
            <a :href="'https://api.whatsapp.com/send?text=' + title + ' - ' + location" @click="track" target="_blank">
                <img alt="share-whatsapp" src="/img/icons/share-whatsapp.svg" />
            </a> 

            <a :href="'fb-messenger://share/?link=' + location" @click="messengerShare">
                <img alt="share-messenger" src="/img/icons/share-messenger.svg" />
            </a>

            <a :href="facebookShareLink" @click="facebookShare">
                <img alt="share-facebook" src="/img/icons/share-facebook.svg" />
            </a>

            <a :href="twitterShareLink" @click="twitterShare">
                <img alt="share-twitter" src="/img/icons/share-twitter.svg" />
            </a>

            <a
                class="copy"
                @click="copy"
                ref="cp_container"
            >
                <img alt="copy" src="/img/icons/copy.svg" />
            </a>
        </div>
    </div>
</template>

<script>
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import Modal from '../Modal'
import ModalOpener from '../ModalOpener'
import ShareWithFriend from '../form/ShareWithFriend'

export default {
    components: {
        'modal': Modal,
        'modal-opener': ModalOpener,
        'share-with-friend': ShareWithFriend,
    },

    props: {
        estate: {
            type: Object,
            required: true, 
        }
    },

    data() {
        return {
            show: false,
            title: document.getElementsByTagName("title")[0].innerHTML,

        }
    },

    computed: {
        lang() {
            return this.$root.lang.estate_detail.share
        },

        location() {
            return window
                ? window.location.href
                : ''
        },

        facebookShareLink() {
            return 'https://www.facebook.com/sharer/sharer.php?u=' + this.location
        },

        twitterShareLink() {
            return 'https://twitter.com/home?status=' + this.location
        }
    },  

    created() {
        // this.watchClickOutside()
    },

    methods: {
        track() {
            if (window.trackLibrary) {
                setTimeout(() =>
                    window.trackLibrary.track('actions.condivisiImmobile', {
                        immobile_id: this.estate.id,
                        agenzia_id: this.estate.agency.id,
                        tipoPagina: 'condivisi',
                        nazione: this.estate.country,
                        origine: (window.location.search.substr(1).split('&').indexOf('origine=newsletter') !== -1) ? 'newsletter' : 'portale'
                    })
                , 100)
            }
            this.toggleMenu
        },

        toggleMenu() {
            console.log(this.show)
            this.show = !this.show
        },

        copy() {
            let container = this.$refs.cp_container
            this.$copyText(window.location.href, container)
            flash(this.lang.flash.success)
            this.track()
        },

        winOpen(link, title) {
            window.open(
                link, 
                title, 
                'left=20,top=20,width=600,height=415,toolbar=1,resizable=0'
            ); 
            this.track()
        },

        facebookShare(event) {
            event.preventDefault()
            this.winOpen(this.facebookShareLink, 'facebook')
            return false
        },

        twitterShare(event) {
            event.preventDefault()
            this.winOpen(this.twitterShareLink, 'twitter')
            return false
        },

        messengerShare(event) {
            event.preventDefault()
            if(FB) {
                FB.ui({
                    method: 'send',
                    link: this.location
                });
            }
           this.track()
        },

        watchClickOutside() {
            window.addEventListener('click', e => {
                if (this.show) {
                    let container = document.getElementById('estate-share')

                    if (! container.contains(e.target)) {
                        this.show = false
                    }
                }
            })
        },
    }
}
</script>

<style>
.menu {
    background: white;
    border: 1px solid green;
    border-radius: 7px;
    position: absolute;
    min-width: 100px;
    width: 250px;
    height: 24px;
    right: 10px;
    z-index: 300;
}
</style>